import React from "react";
import { ICSVModifier } from "modules/Purchases/models/ICSVaditives";
import { SBTranslate } from "i18n";

export interface IDistributionCSVErrors {
	productClientID: string;
	storeClientID: string;
	modifier: number;
	errorMessage: string;
}

export const processDistributionCSV = (
	file: File,
	callback: (validData: ICSVModifier[], hasErrors: boolean) => void,
	setErrorDetails: React.Dispatch<
		React.SetStateAction<IDistributionCSVErrors[]>
	>,
	setValidData: React.Dispatch<React.SetStateAction<ICSVModifier[]>>,
	items: any[],
): void => {
	const reader = new FileReader();
	reader.onload = (e: ProgressEvent<FileReader>) => {
		const text = e.target?.result as string;
		const { validData, hasErrors, errorDetails } = parseAndProcessCSV(
			text,
			items,
		);

		setValidData(validData);
		if (hasErrors) {
			setErrorDetails(errorDetails);
		}
		callback(validData, hasErrors);
	};
	reader.onerror = () => {};
	reader.readAsText(file);
};

const parseAndProcessCSV = (
	csvText: string,
	items: any[],
): {
	validData: ICSVModifier[];
	hasErrors: boolean;
	errorDetails: IDistributionCSVErrors[];
} => {
	let hasErrors = false;
	const validData: ICSVModifier[] = [];
	const errorDetails: IDistributionCSVErrors[] = [];

	const existingIds = new Set(
		items.flatMap((item: any) =>
			(item.plans || []).map(
				(plan: any) =>
					`${item.inventory.product.clientID}-${plan.store?.clientID || plan.inventory?.store?.clientID || ""}`,
			)
		),
	);

	csvText
		.split("\n")
		.slice(1)
		.forEach((row) => {
			const trimmedRow = row.trim();
			if (!trimmedRow) return;

			const columns = trimmedRow.split(SBTranslate("csvSeparator"));
			if (columns.length === 3) {
				const [productClientID, storeClientID, modifierStr] =
					columns.map((col) => col.trim());
				const modifier = parseInt(modifierStr, 10);

				if (
					!isNaN(modifier) &&
					existingIds.has(`${productClientID}-${storeClientID}`)
				) {
					validData.push({
						productClientID,
						storeClientID,
						modifier,
					});
				} else {
					hasErrors = true;
					errorDetails.push({
						productClientID,
						storeClientID,
						modifier: isNaN(modifier) ? 0 : modifier,
						errorMessage: !isNaN(modifier)
							? SBTranslate("noMatchingProductStore")
							: SBTranslate("modifierMustBeInteger"),
					});
				}
			} else {
				hasErrors = true;
				errorDetails.push({
					productClientID: "",
					storeClientID: "",
					modifier: 0,
					errorMessage: SBTranslate("incorrectCSVFormat"),
				});
			}
		});

	return { validData, hasErrors, errorDetails };
};
